// src/dashboard/pages/teacher/Techniques/components/TechniqueDataTable.jsx

import React from "react";
import { FaEdit, FaTrash, FaVideo } from "react-icons/fa";

import {
  getTechniquePhotoSrc,
  DEFAULT_TECHNIQUE_IMAGE,
} from "../utils/techniquesDashboardUtils";

export default function TechniqueDataTable({
  items = [],
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[1080px] w-full">
          <thead className="sticky top-0 z-20">
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="w-28 px-4 py-3 text-left font-bold">Image</th>
              <th className="px-4 py-3 text-left font-bold">Technique</th>
              <th className="px-4 py-3 text-left font-bold">Famille</th>
              <th className="px-4 py-3 text-left font-bold">Ceinture</th>
              <th className="px-4 py-3 text-left font-bold">Contenus</th>
              <th className="sticky right-0 z-30 w-32 bg-slate-50 px-4 py-3 text-right font-bold dark:bg-slate-900">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {items.map((technique) => {
              const hasVideo = !!String(technique.video_url || "").trim();
              const hasUv2 = !!String(technique.uv2 || "").trim();

              return (
                <tr
                  key={technique.id}
                  className="transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-4 py-3">
                    <img
                      src={getTechniquePhotoSrc(technique.image1_url)}
                      alt={technique.nom || "Technique"}
                      className="h-16 w-16 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                      onError={(event) => {
                        event.currentTarget.src = DEFAULT_TECHNIQUE_IMAGE;
                      }}
                    />
                  </td>

                  <td className="px-4 py-3">
                    <div className="font-bold text-slate-900 dark:text-white">
                      {technique.nom || "—"}
                    </div>

                    {technique.traduction ? (
                      <p className="mt-1 text-xs font-medium text-slate-500 dark:text-slate-400">
                        {technique.traduction}
                      </p>
                    ) : null}

                    {technique.information ? (
                      <p className="mt-2 line-clamp-2 max-w-[420px] text-sm leading-6 text-slate-600 dark:text-slate-300">
                        {technique.information}
                      </p>
                    ) : null}
                  </td>

                  <td className="px-4 py-3">
                    <span className="inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                      {technique.famille || "—"}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <span className="inline-flex rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-bold text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
                      {technique.ceinture || "—"}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-2">
                      {hasVideo ? (
                        <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-bold text-rose-700 ring-1 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20">
                          <FaVideo />
                          Vidéo
                        </span>
                      ) : null}

                      {hasUv2 ? (
                        <span className="inline-flex rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-bold text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20">
                          UV2
                        </span>
                      ) : null}

                      {!hasVideo && !hasUv2 ? (
                        <span className="text-sm text-slate-400">—</span>
                      ) : null}
                    </div>
                  </td>

                  <td className="sticky right-0 z-10 bg-white px-4 py-3 dark:bg-slate-900">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onEdit(technique)}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                        title="Modifier"
                      >
                        <FaEdit />
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(technique)}
                        disabled={deletingId === technique.id}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                        title="Supprimer"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}